import styled from '@emotion/styled';
import { COLORS, DOTTED_FOCUS } from '../../constants';

export const StyledMainHeading = styled.span`
  margin: 38px 0px auto 0px;
  left: 0px;
  font-size: 16px;
  font-style: normal;
  line-height: 1.5;
  font-weight: 800;
  color: ${COLORS.white};

  ${DOTTED_FOCUS};

  text-transform: uppercase;
`;

export const StyledExemplarMainContentTitle = styled.span<{ bold?: boolean }>`
  ${({ bold }) => (bold ? 'font-weight: 700;' : '')}
  @media (max-width: 768px) {
    display: none;
  }
`;
